export type NavLinkItem = {
  id: string;
  to: string;
};

export type NavGroup = {
  id: string;
  items: NavLinkItem[];
};

export type NavEntry = NavLinkItem | NavGroup;

export function isNavGroup(entry: NavEntry): entry is NavGroup {
  return 'items' in entry;
}

/** Header menu, aligned with Mahan's information architecture and Soroush routes. */
export const siteNav: NavEntry[] = [
  {
    id: 'book',
    items: [
      { id: 'buyTicket', to: '/search' },
      { id: 'checkin', to: '/manage?mode=checkin' },
      { id: 'refund', to: '/manage?mode=refund' },
      { id: 'change', to: '/manage?mode=change' },
      { id: 'transfer', to: '/guide/transfer' },
    ],
  },
  {
    id: 'travelInfo',
    items: [
      { id: 'buyGuide', to: '/guide/buy' },
      { id: 'manageGuide', to: '/guide/manage' },
      { id: 'refundGuide', to: '/guide/refund' },
      { id: 'checkinGuide', to: '/guide/checkin' },
      { id: 'reduced', to: '/guide/reduced-mobility' },
      { id: 'medical', to: '/guide/medical' },
      { id: 'minor', to: '/guide/unaccompanied-minor' },
      { id: 'meals', to: '/guide/special-meals' },
      { id: 'lounge', to: '/guide/lounge' },
      { id: 'requirements', to: '/guide/travel-requirements' },
      { id: 'baggage', to: '/guide/baggage' },
      { id: 'dangerous', to: '/guide/dangerous-goods' },
      { id: 'animals', to: '/guide/live-animals' },
      { id: 'lost', to: '/guide/lost-baggage' },
      { id: 'safety', to: '/guide/safety' },
    ],
  },
  {
    id: 'inflight',
    items: [
      { id: 'fleet', to: '/guide/fleet' },
      { id: 'seats', to: '/guide/seats' },
      { id: 'cabins', to: '/guide/cabins' },
      { id: 'crew', to: '/guide/crew' },
      { id: 'dining', to: '/guide/dining' },
      { id: 'entertainment', to: '/guide/entertainment' },
      { id: 'magazine', to: '/guide/magazine' },
    ],
  },
  {
    id: 'destinations',
    items: [
      { id: 'domestic', to: '/destinations/domestic' },
      { id: 'international', to: '/destinations/international' },
      { id: 'tourism', to: '/guide/tourism' },
    ],
  },
  { id: 'club', to: '/miles' },
];

export function isItemActive(to: string, pathname: string, search: string): boolean {
  const [path, query] = to.split('?');
  if (pathname !== path) return false;
  if (!query) return true;
  const expected = new URLSearchParams(query);
  const actual = new URLSearchParams(search);
  for (const [key, value] of expected) {
    if (actual.get(key) !== value) return false;
  }
  return true;
}

export function findGuide(slug: string): { item: NavLinkItem; groupId: string } | undefined {
  for (const entry of siteNav) {
    if (!isNavGroup(entry)) continue;
    const match = entry.items.find((item) => item.to === `/guide/${slug}`);
    if (match) return { item: match, groupId: entry.id };
  }
  return undefined;
}
